import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import GenericHelmet from '@client/helperComponents/genericHelmet/GenericHelmet';
import { ErrorBox } from '@client/components/errorBox/ErrorBox';
import { selectHelmetData } from './duckNotFoundPage';

class NotFoundPage extends PureComponent {
  render() {
    const { helmetData } = this.props;

    return (
      <>
        <GenericHelmet helmetData={helmetData} />
        <ErrorBox />
      </>
    );
  }
}

NotFoundPage.propTypes = {
  dispatch: PropTypes.func,
  text: PropTypes.string,
  helmetData: ImmutablePropTypes.map,
};

function mapStateToProps(state) {
  return {
    helmetData: selectHelmetData(state),
  };
}

export default connect(mapStateToProps)(NotFoundPage);
